<template>
    <span>
        <slot v-if="!soltText"></slot>
        <template v-else>
            {{ i18nConfig(soltText) }}
        </template>
    </span>
</template>

<script>
import { i18nConfig } from '@/utils/ruoyi'
import { reactive, toRefs, getCurrentInstance, onMounted, nextTick } from 'vue'
export default {
    name: "gljy-span",
    setup() {

        const { proxy } = getCurrentInstance();
        const datas = reactive({
            i18nConfig: i18nConfig,
            soltText: undefined,
        })

        const methods = {
        }

        onMounted(() => {
            nextTick(() => {
                try {
                    const slotDefault = proxy.$slots?.default();
                    if (slotDefault.length == 1 && typeof slotDefault[0].type == "symbol") {
                        datas.soltText = slotDefault[0].children?.trim();
                    }
                } catch (e) {
                }
            })
        })

        return {
            ...toRefs(datas),
            ...methods
        }
    }
}
</script>

<style></style>